var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 13.6565H9.8V12.1097H8.2V13.6565ZM9 1.28206C4.584 1.28206 1 4.74689 1 9.01605C1 13.2852 4.584 16.75 9 16.75C13.416 16.75 17 13.2852 17 9.01605C17 4.74689 13.416 1.28206 9 1.28206ZM9 15.2032C5.472 15.2032 2.6 12.4267 2.6 9.01605C2.6 5.60536 5.472 2.82886 9 2.82886C12.528 2.82886 15.4 5.60536 15.4 9.01605C15.4 12.4267 12.528 15.2032 9 15.2032ZM9 4.37566C7.232 4.37566 5.8 5.76004 5.8 7.46925H7.4C7.4 6.61852 8.12 5.92246 9 5.92246C9.88 5.92246 10.6 6.61852 10.6 7.46925C10.6 9.01605 8.2 8.8227 8.2 11.3363H9.8C9.8 9.5961 12.2 9.40275 12.2 7.46925C12.2 5.76004 10.768 4.37566 9 4.37566Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.315308,
    width: 18,
    height: 17.4015,
    fill: "#979797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.77c4215ef884c2a1a5c6ac5927166339.svg";
export { ForwardRef as ReactComponent };